"use client";

import { DateRangeISOString } from "@costar/date-picker";
import React, { useState } from "react";
import { ContainerLoader } from "../common/loaders/ContainerLoader";
import { SearchFilterAlley, filterAlleyMessages } from "./SearchFilterAlley";

interface categoryOption {
  id: string;
  value: string;
  name: string;
  checked: boolean;
  disabled: boolean;
}

interface labelOption {
  id: string;
  value: string;
  name: string;
  checked: boolean;
  disabled: boolean;
}

export interface ISearchFilterProps {
  categoryOptions: categoryOption[];
  labelOptions: labelOption[];
  baseUrl: string;
  redirectUrl: string;
  keyword: string;
  messages: filterAlleyMessages;
  onClick?: () => void;
  dateRange: DateRangeISOString;
}

export const SearchFilter = (props: ISearchFilterProps) => {
  const {
    categoryOptions,
    labelOptions,
    baseUrl,
    redirectUrl,
    keyword,
    messages,
    onClick,
    dateRange,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      {isLoading && <ContainerLoader className="absolute h-full" />}
      <SearchFilterAlley
        dateRange={dateRange}
        messages={messages}
        categoryOptions={categoryOptions}
        labelOptions={labelOptions}
        baseUrl={baseUrl}
        redirectUrl={redirectUrl}
        keyword={keyword}
        onClick={onClick}
        setIsFilterLoading={setIsLoading}
      ></SearchFilterAlley>
    </>
  );
};
